import { useTranslation } from 'react-i18next';
import { useParamsSearch } from '@anytag/shared-hooks';
import { ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useInfluencerYoutubeAnalyticsShortsQuery } from '@anytag/graphql';
import { ProfilePostsCount, ProfilePostsFilter, InfluencerYoutubeShortsList } from '@anytag/shared-organisms';
import { useInitialInfluencerPostsListWithName } from '../hooks';
import { InfluencerYoutubeShortsSearchSchemaType } from './schema-types';

export const InfluencerYoutubeShorts = () => {
  const { t } = useTranslation();
  const { influencerId, mainSocialAccountId } = useInitialInfluencerPostsListWithName({
    title: 'Shorts List',
    titleWithName: 'appHeader.ShortsWithAccountName'
  });
  const { page, limit, sort, filter, setFilter } = useParamsSearch<InfluencerYoutubeShortsSearchSchemaType>();
  const { data, previousData, loading } = useInfluencerYoutubeAnalyticsShortsQuery({
    skip: !influencerId || !mainSocialAccountId,
    variables: getValuableVariables({
      limit,
      socialAccountId: mainSocialAccountId,
      orderBy: sort,
      offset: getOffset(page, limit),
      ...filter
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.influencerYoutubeAnalyticsShortsCount?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <ProfilePostsFilter filter={filter} setFilter={setFilter} hasPeriod />

      <ProfilePostsCount count={totalRecords} countLabel={t('Shorts found')} />

      <InfluencerYoutubeShortsList
        loading={loading}
        mainSocialAccountId={mainSocialAccountId}
        data={result?.influencerYoutubeAnalyticsShorts?.shorts || []}
      />
    </ListWithPagination>
  );
};
